<template>
  <a-tree
    block-node
    :tree-data="showTree"
    checkable
    checkStrictly
    v-model:checkedKeys="checkedKeys"
    :fieldNames="{ title: 'name', key: 'permission_id' }"
    defaultExpandAll
    v-if="showTree?.length"
  ></a-tree>
  <a-button type="primary" @click="handelBind">提交</a-button>
</template>
<script setup>
  import { ref, defineProps, defineEmits, onMounted } from 'vue'
  import { message } from 'ant-design-vue'
  import { buildTree } from '@/utils/tree'
  import { getPerm, getRolePerm } from '@/api/system_manage/perm'
  import { roleBindPerm } from '@/api/system_manage/role'

  const props = defineProps({ editData: Object })
  const emit = defineEmits(['submit'])
  const data = ref()
  const treeData = ref()
  const showTree = ref()
  const checkedKeys = ref()

  async function handelBind() {
    const res = await roleBindPerm({
      roleId: props.editData.role_id,
      permissionIds: (
        checkedKeys.value.checked || checkedKeys.value
      ).toString(),
    })
    if (res.success) {
      message.success('绑定权限成功！')
      emit('bind')
    } else {
      message.warn('绑定权限错误：', res.message)
    }
  }
  function fetch() {
    getPerm().then((res) => {
      if (res.success) {
        data.value = res.data
        const tree = buildTree(res.data, { idName: 'permission_id' })
        treeData.value = tree
        showTree.value = tree
      }
    })
    getRolePerm({ roleId: props.editData.role_id }).then((res) => {
      if (res.success) {
        checkedKeys.value = res.data.map((role) => role.permission_id)
      }
    })
  }
  onMounted(() => {
    fetch()
  })
</script>
